const COLORS = {
  primary: '#f7b832',
  primaryMiddle: '#f3be4d',
  primaryLight: '#fae9c4',
  secondary: '#4d4d4f',
  secondaryMiddle: '#7c7c7d',
  secondaryLight: '#e7e7e7',
  positive: '#4daa9e',
  negative: '#c2392c',
  text: '#dededf',
  textDark: '#4e4e50',
  textLight: '#d59d29',
  textStandard: '#fff',
  elementEven: '#f0f0f0',
  elementOdd: '#e7e7e7',
  elementBorder: '#dbdbdb',
  success: '#4daa9e',
  error: '#c2392c',
  errorLight: '#f8d7da',
  warning: '#F39629',
  info: '#5199ff',
  sourceLineNumber: '#FDF6E7',
  primaryBackground: '#fff',
  buttonBorderDark: '#9d9d9d',
  topBarBorderColor: '#c3c3c3',
  sidebarTitleBackground: '#585858',
  sidebarChapterListItemBackground: '#666666',
  sidebarMaterialTypeColor: '#9d9d9d',
  sidebarMaterialBackgroundColorHover: '#919191',
  notAllowed: '#d3d3d3',
  inlineCodeBackground: '#f5f5f5',
  inlineCodeBorder: '#e2e2e2',
  gradebookTableText: '#373737',
  gradebookScore: '#999999',
};

const FONT_SIZES = {
  primary: '1.4rem',
  secondary: '1.6rem',
  small: '1.1rem',
  medium: '1.5rem',
  large: '1.9rem',
  alert: '1.8rem',
  sourceLineNumber: '1.2rem',
  sidebarCourseName: '2rem',
  sidebarSignature: '1.2rem',
  article: '1.8rem',
  tag: '1.2rem',
};

const SCREEN_SIZES = {
  mobile: '576px',
  tablet: '768px',
  laptop: '1024px',
};

const MEDIA_MIN = {
  mobile: `min-width: ${SCREEN_SIZES.mobile}`,
  tablet: `min-width: ${SCREEN_SIZES.tablet}`,
  laptop: `min-width: ${SCREEN_SIZES.laptop}`,
};

const MEDIA_MAX = {
  mobile: `max-width: ${SCREEN_SIZES.mobile}`,
  tablet: `max-width: ${SCREEN_SIZES.tablet}`,
  laptop: `max-width: ${SCREEN_SIZES.laptop}`,
};

// new ui

const TYPOGRAPHY = {
  h1: {
    fontWeight: 300,
    fontSize: '3.6rem',
  },
  h2: {
    fontWeight: 500,
    fontSize: '2.4rem',
  },
  bodyText: {
    fontWeight: 400,
    fontSize: '1.6rem',
  },
  bodyTextSmall: {
    fontWeight: 400,
    fontSize: '1.4rem',
  },
  label: {
    fontWeight: 400,
    fontSize: '1.2rem',
  },
  headerLabel: {
    fontWeight: 400,
    fontSize: '1.1rem',
  },
};

const UI_COLORS = {
  primary: '#FBB600',
  secondary: '#2A3030',
  light: '#fff',
  alert: '#FF7A00',
  error: '#B96082',
  info: '#63D0EE',
  success: '#50B779',
  main_gray: '#E1E4E4',
  medium_gray: '#778888',
  background: '#F2F2F2',
  label: '#6452A3',
  labelShadow: '#362477',
};

export const defaultTheme = {
  COLORS,
  FONT_SIZES,
  SCREEN_SIZES,
  MEDIA_MAX,
  MEDIA_MIN,
  TYPOGRAPHY,
  UI_COLORS,
};
